"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var bundle_datepicker_1 = __importDefault(require("../../../components/bundle-datepicker"));
var callout_1 = require("../../../components/callout");
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var save_button_1 = require("../../../components/save_button");
var update_next_charge_date_1 = require("../../../mutations/update-next-charge-date");
var order_now_modal_1 = __importDefault(require("./order-now-modal"));
var skip_shipment_modal_1 = __importDefault(require("./skip-shipment-modal"));
exports.default = (function (_a) {
    var _b, _c, _d;
    var groupedSubscription = _a.groupedSubscription, customerData = _a.customerData, openDrawer = _a.openDrawer, setOpenDrawer = _a.setOpenDrawer;
    var _e = __read((0, react_1.useState)(new Date(groupedSubscription.subscription.next_charge_scheduled_at)), 2), startDate = _e[0], setStartDate = _e[1];
    var onChange = function (date) {
        setStartDate(date);
    };
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var _f = (0, react_query_1.useMutation)('updateNextShipDate', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_next_charge_date_1.UPDATE_NEXT_CHARGE_DATE, variables); }, {
        onSuccess: function () {
            queryClient.invalidateQueries('getCustomerSubscriptions');
            callout.success('Successfully Updated Order Date!');
        },
    }), updateNextShipDate = _f.mutateAsync, isUpdatingNextChargeDate = _f.isLoading, isError = _f.isError;
    var onEditNextChargeDateSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!groupedSubscription.subscription.id) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateNextShipDate({
                            nextChargeDate: startDate.toISOString(),
                            subscriptionId: groupedSubscription.subscription.id,
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isUpdatingNextChargeDate, error: isError }),
        react_1.default.createElement("div", { className: 'horizontal-divider' }),
        react_1.default.createElement("a", { onClick: function () { return setOpenDrawer(openDrawer === 'next_ship_date' ? undefined : 'next_ship_date'); } },
            react_1.default.createElement("div", { className: 'account-subheader solid-border-top' },
                "Next Order Date",
                react_1.default.createElement("span", { className: "arrow ".concat(openDrawer === 'next_ship_date' ? 'up' : 'down') })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, (0, date_fns_1.format)((0, date_fns_1.parseISO)(groupedSubscription.subscription.next_charge_scheduled_at), 'MMM dd, yyyy')))),
        ((_d = (_c = (_b = window.accountApp) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.shipNowModal) === null || _d === void 0 ? void 0 : _d.isEnabled) && (react_1.default.createElement("div", { className: (0, classnames_1.default)({ hide: openDrawer === 'next_ship_date' }) },
            react_1.default.createElement(order_now_modal_1.default, { subscription: groupedSubscription, customerData: customerData }),
            react_1.default.createElement(skip_shipment_modal_1.default, { subscription: groupedSubscription }))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('account-drawer-content', { open: openDrawer === 'next_ship_date' }) },
            react_1.default.createElement("div", { className: 'text-center padding-top-5' },
                react_1.default.createElement(bundle_datepicker_1.default, { selected: startDate, onChange: onChange, startDate: startDate, maxDate: (0, date_fns_1.addMonths)(new Date(), 3), inline: true }),
                react_1.default.createElement(save_button_1.SaveButton, { onClick: onEditNextChargeDateSubmit, isLoading: isUpdatingNextChargeDate })))));
});
